// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2937 ? "eabe11fc" : chunkId) + "." + {"1167":"923f441cb473e9f0","2937":"638adbfd956ba5a8"}[chunkId] + ".js";
};